import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const InputRichText = props => {
    const { attribute, returnType, value, placeholder, eventsHandler } = props;
    const [ firstPassed, setFirstPassed ] = useState(true);
    const [ entry, setEntry ] = useState(value);

    const changeEvent = () => {
        if (eventsHandler.handleChange === undefined || eventsHandler.handleChange === null) return;

        eventsHandler.handleChange(attribute, returnType, entry);
    }

    useEffect(() => {
		if (!firstPassed)
        	changeEvent();

		setFirstPassed(false);
    }, [entry]);

    return (
		<ReactQuill id={"richInput"} className={"richInput"} theme={"snow"} placeholder={placeholder} value={entry} onChange={setEntry} />
    );
}

export default InputRichText;
